//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ConsumeManage',
  components: {
    consume: function consume() {
      return import('../fixed/components/consume');
    }
  }
};